export default {
  blocks: [
    {
      key: '4i3kf',
      text: 'Paragraph with invalid style',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
  entityMap: {},
  VERSION: '8.70.22',
  ID: 'c2e1f570-2729-4cb6-b973-99a1115dd7cb',
};
